import EtablissementNumero from '@/generated/controls/etablissement/EtablissementNumero.vue';
import { defineComponent } from "vue";

export default defineComponent({
    components: {},
    extends: EtablissementNumero
})

